// extracted by mini-css-extract-plugin
export default {"semi-bold":"useCancelScheduledAvailability_semi-bold__XDyzD"};